import { Outlet } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
import NavSection from "./NavSection";

const APP_BAR_HEIGHT = 72;

const StyledRoot = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
  backgroundColor: "var(--dl-bg)",
  color: "var(--dl-text)",
});

const Main = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  backgroundColor: "var(--dl-bg)",
  paddingTop: APP_BAR_HEIGHT,
  paddingLeft: 0,
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_HEIGHT,
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export default function DashboardLayout() {
  return (
    <div>
      <StyledRoot>
        <NavSection/>
        <Main>
          <Outlet />
        </Main>
      </StyledRoot>
    </div>
  );
}
